import React, { useEffect } from "react";

import { passwordStrength } from "check-password-strength";

import { useTranslation } from "utils";

import { Button, Form, StickyFooterButtons, Message as message } from "components";

export const ConfirmAccountButtons = ({ loading, step, setStep }: { loading: boolean; step: number; setStep: (step: number) => void }) => {
  const { t } = useTranslation(["signinup", "meta", "enums"]);
  const form = Form.useFormInstance();

  const title = Form.useWatch("title", form);
  const firstName = Form.useWatch("firstName", form);
  const lastName = Form.useWatch("lastName", form);
  const password = Form.useWatch("password", form);
  const confirmPassword = Form.useWatch("confirmPassword", form);
  const phone = Form.useWatch("phone", form);

  const handleStep1Change = () => {
    const passwordAnalysis = passwordStrength(password);
    if (passwordAnalysis.contains.length < 2 || password.length < 6) {
      return message({
        content: t("password.weak"),
        icon: "error",
      });
    }
    if (!title || !firstName || !lastName || !password || !confirmPassword) {
      return message({ content: t("errors.mandatoryFields"), icon: "error" });
    }
    if (firstName.includes("@") || lastName.includes("@")) {
      return message({
        content: t("confirm.inputs.noEmailInName"),
        icon: "error",
      });
    }
    if (password !== confirmPassword) {
      return message({ content: t("password.notMatching"), icon: "error" });
    }

    setStep(2);
  };

  useEffect(() => {
    const backHandler = () => {
      setStep(1);
    };
    window.addEventListener("popstate", backHandler);
    return () => {
      window.removeEventListener("popstate", backHandler);
    };
  }, [setStep]);

  return (
    <StickyFooterButtons
      handleBack={step === 2 ? () => setStep(1) : undefined}
      backButtonText={step === 2 ? t("confirm.buttons.back") : undefined}
      className="confirm-account-footer"
    >
      {step === 1 && (
        <Button
          dataTestId="confirm-button-continue-step-1"
          onClick={() => handleStep1Change()}
          type="primary"
          disabled={!title || !firstName || !lastName || !password || !confirmPassword}
        >
          {t("confirm.buttons.continue")}
        </Button>
      )}
      {step === 2 && (
        <Form.Item>
          <Button dataTestId="confirm-button-submit" disabled={loading || !phone} htmlType="submit" loading={loading} type="primary">
            {t("confirm.buttons.confirm")}
          </Button>
        </Form.Item>
      )}
    </StickyFooterButtons>
  );
};
